import {Card} from "../../../basic/card.tsx";
import {ExternalLink} from "lucide-react";
import {Button} from "../../../basic/button.tsx";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {getVelasolarisUrl} from "../../../../utils/websiteUrlUtils";

export function SupportResources() {
    const {t, i18n} = useTranslationWithKeys();

    return (
        <Card className="p-6 shadow-sm border-border/50 bg-accent/20">
            <div className="flex items-center justify-between">
                <div>
                    <h3 className="mb-1">{t('support.needMoreResources')}</h3>
                    <p className="text-muted-foreground">
                        {t('support.needMoreResourcesDescription')}
                    </p>
                </div>
                <Button
                    variant="outline"
                    className="gap-2"
                    onClick={() => window.open(getVelasolarisUrl('support/', i18n.language), '_blank')}
                >
                    <ExternalLink className="h-4 w-4"/>
                    {t('support.visitSupport')}
                </Button>
            </div>
        </Card>
    );
}
